import React from 'react';
import { Link } from 'react-router-dom';

function Footer() {
   const email = "sladejustincredible@gmail.com";
   const phone = "4389241294";
   const formattedPhone = `(${phone.slice(0, 3)}) ${phone.slice(3, 6)}-${phone.slice(6)}`;

   return (
      <footer className="text-gray-800 border-t border-gray-400">
         <div className="max-w-7xl mx-auto px-4 py-16 flex flex-col items-center">
            {/* CTA Section */}
            <div className="text-center mb-12">
               <h2 className="text-5xl md:text-6xl font-light text-gray-900 mb-6">Let's Collaborate</h2>
               <p className="text-lg mt-4 mb-6 text-gray-600">
                  I'm always excited to work on new projects.
               </p>
               <Link
                  to="/contact"
                  className="inline-block border border-gray-700 text-gray-800 px-8 py-3 rounded transition hover:bg-gray-700 hover:text-white"
               >
                  Get In Touch
               </Link>
            </div>

            {/* Contact Cards */}
            <div className="w-full flex flex-col md:flex-row justify-evenly items-center gap-6 mb-12">
               {/* Email Card */}
               <div className="group w-full md:w-auto px-6 py-4">
                  <div className="flex items-center gap-4">
                     <div className="text-2xl text-gray-600 group-hover:text-gray-900 transition-transform duration-300 group-hover:scale-110">
                        <i className="fas fa-envelope"></i>
                     </div>
                     <a
                        href={`mailto:${email}`}
                        className="text-lg font-light text-gray-800 group-hover:text-gray-900 transition-colors relative"
                     >
                        {email}
                        <span className="absolute left-0 -bottom-1 h-[1px] w-0 bg-gray-400 transition-all duration-300 group-hover:w-full"></span>
                     </a>
                  </div>
               </div>

               {/* Phone Card */}
               <div className="group w-full md:w-auto px-6 py-4">
                  <div className="flex items-center gap-4">
                     <div className="text-2xl text-gray-600 group-hover:text-gray-900 transition-transform duration-300 group-hover:scale-110">
                        <i className="fas fa-phone-alt"></i>
                     </div>
                     <a
                        href={`tel:+1${phone}`}
                        className="text-lg font-light text-gray-700 group-hover:text-gray-900 transition-colors relative"
                     >
                        +1 {formattedPhone}
                        <span className="absolute left-0 -bottom-1 h-[1px] w-0 bg-gray-400 transition-all duration-300 group-hover:w-full"></span>
                     </a>
                  </div>
               </div>
            </div>

            {/* Social Icons */}
            <div className="flex space-x-4 mb-10">
               <a
                  href="https://www.linkedin.com/in/sladejustinferrao"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-3xl text-gray-600 hover:text-blue-600 transition"
               >
                  <i className="fab fa-linkedin"></i>
               </a>
               <a
                  href="https://github.com/SladeJustinFerrao"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-3xl text-gray-600 hover:text-black transition"
               >
                  <i className="fab fa-github"></i>
               </a>
               <a
                  href="https://twitter.com/your-twitter"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-3xl text-gray-600 hover:text-black transition"
               >
                  <i className="fab fa-x-twitter"></i>
               </a>
               <a
                  href="https://www.instagram.com/sladeferrao/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-3xl text-gray-600 hover:text-pink-500 transition"
               >
                  <i className="fab fa-instagram"></i>
               </a>
               <a
                  href="https://www.youtube.com/@sladejustinferrao"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-3xl text-gray-600 hover:text-red-500 transition"
               >
                  <i className="fab fa-youtube"></i>
               </a>
            </div>

            {/* Copyright */}
            <div className="text-sm text-gray-500 text-center">
               &copy; {new Date().getFullYear()} <Link to="/admin">Slade Justin Ferrao</Link>. All rights reserved.
            </div>
         </div>
      </footer>
   );
}

export default Footer;
